<template>
  <q-dialog v-model="opened" >
    <q-card>
      <q-toolbar>
        <q-btn
          flat
          round
          dense
          v-close-popup
          icon="keyboard_arrow_left" />
        Settings
      </q-toolbar>
<!--      <q-toolbar>-->
<!--        <q-search inverted v-model="searchTerm" color="none" :debounce="50" placeholder="Search For A Setting" clearable style="width: 100%;"></q-search>-->
<!--      </q-toolbar>-->
      <q-card-section>
        <!--class="q-pa-sm">-->
        <q-list link class="q-px-lg q-pt-none q-ma-md">
          <q-item-label header v-show="isVis('user')">
            User
          </q-item-label>
          <q-item v-show="isVis('user|username|user name')" @click.native="updateUsername">
            <q-item-section avatar>
              <q-icon name="person" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Username</q-item-label>
              <q-item-label caption>@{{vuexUser.username}}</q-item-label>
            </q-item-section>
          </q-item>
          <!--<q-item v-show="isVis('user|display name|username|user name')">-->
            <!--<q-item-section side icon="person" />-->
            <!--<q-item-section>-->
              <!--<q-item-tile>Display Name</q-item-tile>-->
              <!--<q-item-tile caption>{{$store.state.auth.currentUser.displayName}}</q-item-tile>-->
            <!--</q-item-section>-->
          <!--</q-item>-->
          <q-item v-show="isVis('user password|pass|pswd|pwd')" @click.native="updatePassword">
            <q-item-section avatar>
              <q-icon name="lock" />
            </q-item-section>
            <q-item-section>
              <q-item-label>Password</q-item-label>
              <q-item-label caption>Click To Change</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('user email address')" @click.native="updateEmail">
            <q-item-section avatar>
              <q-icon name="email" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Email</q-item-tile>
              <q-item-tile caption>{{user.email}}</q-item-tile>
            </q-item-section>
          </q-item>
          <q-item disabled v-show="isVis('user|notify|notifications')">
            <q-item-section avatar>
              <q-icon name="notifications" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Notifications</q-item-tile>
              <q-item-tile caption>Not implemented yet!</q-item-tile>
            </q-item-section>
          </q-item>
          <q-separator />
          <q-item-label header v-show="isVis('editor')" link>
            Editor
          </q-item-label>
          <q-item v-show="isVis('editor text size|txt size')">
            <q-item-section avatar>
              <q-icon name="format_size" />
            </q-item-section>
            <q-item-section>
              <q-select dense map-options emit-value class="q-ma-none full-width" float-label="Font Size" v-model="settings.editor.fontSize" :options="editorFontSizeOptions" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor tabs|tab spaces')">
            <q-item-section avatar>
              <q-icon name="keyboard_tab" />
            </q-item-section>
            <q-item-section>
              <!--<q-input v-model="editorSpacesPerTab" type="number" float-label="Spaces Per Tab" :step="1" min="1" max="10" :decimals="0" />-->
              <q-select dense map-options emit-value class="q-ma-none full-width" float-label="Spaces Per Tab" v-model="settings.editor.tabSize" :options="editorTabSizeOptions" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor theme|style')">
            <q-item-section avatar>
              <q-icon name="style" />
            </q-item-section>
            <q-item-section>
              <!--<q-input v-model="editorSpacesPerTab" type="number" float-label="Spaces Per Tab" :step="1" min="1" max="10" :decimals="0" />-->
              <q-select dense map-options emit-value class="q-ma-none full-width" float-label="Theme" v-model="settings.editor.theme" :options="editorThemeOptions" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor key bindings|keyboard bindings')">
            <q-item-section avatar>
              <q-icon name="mdi-keyboard-variant\" />
            </q-item-section>
            <q-item-section>
              <q-select dense map-options emit-value class="q-ma-none full-width" float-label="Key Bindings" v-model="settings.editor.keyboardHandler" :options="editorKeyboardHandlerOptions" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor line numbers|line nos|line nums')">
            <q-item-section avatar>
              <q-icon name="format_list_numbered" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Show Line Numbers</q-item-tile>
            </q-item-section>
            <q-item-section side right>
              <q-toggle v-model="settings.editor.showLineNumbers" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor line wrapping')">
            <q-item-section avatar>
              <q-icon name="wrap_text" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Line Wrapping</q-item-tile>
            </q-item-section>
            <q-item-section side right>
              <q-toggle v-model="settings.editor.wrap" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor invisibles')">
            <q-item-section avatar>
              <q-icon name="mdi-format-pilcrow" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Show Invisibles</q-item-tile>
            </q-item-section>
            <q-item-section side right>
              <q-toggle v-model="settings.editor.showInvisibles" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor show print margin')">
            <q-item-section avatar>
              <q-icon name="wrap_text" />
            </q-item-section>
            <q-item-section>
              <q-item-tile>Show Print Margin</q-item-tile>
            </q-item-section>
            <q-item-section side right>
              <q-toggle v-model="settings.editor.printMargin" @input="saveSettings" />
            </q-item-section>
          </q-item>
          <q-item v-show="isVis('editor code folding')">
            <q-item-section avatar>
              <q-icon name="format_list_numbered" />
            </q-item-section>
            <q-item-section>
              <!--<q-input v-model="editorSpacesPerTab" type="number" float-label="Spaces Per Tab" :step="1" min="1" max="10" :decimals="0" />-->
              <q-select dense map-options emit-value class="q-ma-none full-width" float-label="Code Folding" v-model="settings.editor.foldStyle" :options="editorFoldStyleOptions" @input="saveSettings" />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import firestore from '../store/firestore'

export default {
  // name: 'ComponentName',
  data () {
    return {
      editorFontSizeOptions: [],
      editorTabSizeOptions: [],
      editorThemeOptions: [],
      editorFoldStyleOptions: [],
      editorKeyboardHandlerOptions: []
    }
  },
  computed: {
    opened: {
      get () { return this.$store.state.ui.settingsOpen },
      set (v) { this.$store.commit('setSettingsOpen', v) }
    },
    settings () { return this.vuexUser.settings },
    searchTerm: {
      get () { return this.$store.state.ui.settingsSearchTerm },
      set (v) { this.$store.commit('setSettingsSearchTerm', v) }
    },
    user () {
      return firebase.auth().currentUser
    },
    vuexUser () {
      return this.$store.state.auth.currentUser
    }
  },
  methods: {
    isVis (item) {
      return item.indexOf(this.searchTerm) >= 0
    },
    saveSettings () {
      this.$store.dispatch('updateCurrentUser')
    },
    updatePassword () {
      this.$q.dialog({
        title: 'Update Password',
        message: 'Please enter a new password',
        prompt: {
          model: '',
          type: 'password'
        },
        cancel: true,
        color: 'primary'
      }).then((data1) => {
        this.$q.dialog({
          title: 'Update Password',
          message: 'Please repeat the new password',
          prompt: {
            model: '',
            type: 'password'
          },
          cancel: true,
          color: 'secondary'
        }).then((data2) => {
          if (data1 === data2) {
            firebase.auth().currentUser.updatePassword(data1).then(() => {
              this.$q.notify({
                message: 'Password changed!',
                type: 'positive'
              })
            }).catch((err) => {
              this.$q.notify({
                message: 'Password not changed. ' + err,
                type: 'negative'
              })
            })
          } else {
            this.$q.notify({
              message: 'The passwords didn\'t match.  Please try again.',
              type: 'negative'
            })
          }
        })
      })
    },
    updateEmail () {
      this.$q.dialog({
        title: 'Update Email',
        message: 'Please enter a new email',
        prompt: {
          model: '',
          type: 'email'
        },
        cancel: true,
        color: 'primary'
      }).then((data1) => {
        this.$q.dialog({
          title: 'Update Email',
          message: 'Please repeat the new email',
          prompt: {
            model: '',
            type: 'email'
          },
          cancel: true,
          color: 'secondary'
        }).then((data2) => {
          if (data1 === data2) {
            firebase.auth().currentUser.updateEmail(data1).then(() => {
              this.$q.notify({
                message: 'Email changed!',
                type: 'positive'
              })
            }).catch((err) => {
              this.$q.notify({
                message: 'Email not changed. ' + err,
                type: 'negative'
              })
            })
          } else {
            this.$q.notify({
              message: 'The emails didn\'t match.  Please try again.',
              type: 'negative'
            })
          }
        })
      })
    },
    updateUsername () {
      this.$q.dialog({
        title: 'Update Username',
        message: 'Please enter a new username',
        prompt: {
          model: '',
          type: 'text'
        },
        cancel: true,
        color: 'primary'
      }).then((newUsername) => {
        firestore.functions().httpsCallable('setUsername')(newUsername).then((result) => {
          this.$q.notify({
            message: 'Username changed!',
            type: 'positive'
          })
        }).catch((err) => {
          console.log(err.code)
          console.log(err.message)
          console.log(err.details)
          console.log(err)
          this.$q.notify({
            message: 'Username not changed. ' + err,
            type: 'negative'
          })
        })
      })
    }
  },
  mounted () {
    let sizes = [5, 6, 7, 8, 10, 12, 14, 16, 18, 20, 24]
    sizes.forEach(size => {
      this.editorFontSizeOptions.push({
        label: size + ' px',
        value: size + 'px'
      })
    })
    sizes = [1, 2, 4, 8]
    sizes.forEach(size => {
      this.editorTabSizeOptions.push({
        label: size + '',
        value: size + ''
      })
    })
    this.editorThemeOptions = [
      {
        label: 'Default',
        value: 'default'
      },
      {
        label: 'Dracula',
        value: 'dracula'
      },
      {
        label: 'Neat',
        value: 'neat'
      },
      {
        label: 'Oceanic',
        value: 'oceanic'
      },
      {
        label: 'Monokai',
        value: 'monokai'
      }
    ]
    this.editorFoldStyleOptions = [
      {
        label: 'At Start of Block',
        value: 'markbegin'
      },
      {
        label: 'At Start and End of Block',
        value: 'markbeginend'
      },
      {
        label: 'Off',
        value: 'manual'
      }
    ]
    this.editorKeyboardHandlerOptions = [
      {
        label: 'Default',
        value: 'ace'
      },
      {
        label: 'Vim',
        value: 'vim'
      },
      {
        label: 'Emacs',
        value: 'emacs'
      }
    ]
  }
}
</script>

<style>
</style>
